/**
 * proposalPermissions.ts
 *
 * Proposal AI Draft Review module permission constants and helpers.
 *
 * Design principles:
 * - No React imports; pure TypeScript so it can be tested in Vitest without
 *   a DOM environment.
 * - Mirrors the backend `@RequirePermission('proposal.*', '...')` decorators.
 * - Permission strings follow the pattern `<resource>:<action>`.
 */

// Re-export the shared hasPermission helper so proposal pages only need one import
export { hasPermission } from './crmPermissions';

export const PROPOSAL_PERMISSIONS = {
  PROPOSAL_READ: 'proposal.proposal:read',
  PROPOSAL_CREATE: 'proposal.proposal:create',
  PROPOSAL_UPDATE: 'proposal.proposal:update',
  PROPOSAL_LOCK: 'proposal.proposal:lock',
  REVIEW_CREATE: 'proposal.review:create',
} as const;

export type ProposalPermission =
  (typeof PROPOSAL_PERMISSIONS)[keyof typeof PROPOSAL_PERMISSIONS];
